// React binding for the SSE bridge: connects only while authenticated and
// tears the connection down on logout or account change.

import { useSession } from '@/session/SessionProvider';
import { useEventStream } from './eventStream';

export function useLiveEvents(): void {
  const { accountId, state } = useSession();
  const enabled = state.status === 'authenticated';
  useEventStream(accountId, enabled);
}
